<template>
  <div class="d-flex flex-column align-center rounded-lg py-1 elevation-6"
    :style="{ width: '45px', 'background-color': settings.color }"
  >
    <v-icon :color="settings.dark ? 'black' : 'white'">
      {{ settings.icon }}
    </v-icon>
    <div style="font-size: 10px; line-height: 12px" 
      :class="{ 'black--text': settings.dark, 'white--text': !settings.dark }"
    >
      {{ settings.label }}
    </div>
  </div>
</template>

<script>
import colors from 'vuetify/lib/util/colors'

export default {
  props: ['status'],

  data() {
    return {
      status_icons: {
        'disputed': { icon: 'mdi-note-search-outline', color: colors.grey.base,  label: 'Disp.' },
        'disqualified': { icon: 'mdi-timer-lock-outline', color: colors.grey.base,  label: 'Locked' },
        'locked': { icon: 'mdi-timer-lock-outline', color: colors.grey.base,  label: 'Locked' },
        'lost': { icon: 'mdi-thumb-down-outline', color: colors.blueGrey.lighten1,  label: 'Lost' },
        'new':  { icon: 'mdi-alert-outline', color: '#F7FC14', label: 'New', dark: true },
        'open': { icon: 'mdi-progress-check', color: colors.green.darken2,  label: 'Open' },
        'refunded': { icon: 'mdi-note-search-outline', color: colors.grey.base,  label: 'Refund' },
        'won':  { icon: 'mdi-thumb-up-outline', color: colors.blue.darken2, label: 'Won' },
      },
    }
  },

  computed: {
    settings() {
      return this.status_icons[this.status]
    }
  }
}
</script>
